import React from 'react';
import { Field } from 'formik';
import { CustomForm } from '.generated/Feature.Irwinmitchell.model';

interface HeaderFieldProps {
  field: CustomForm.FormField_Item;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  isStandalone?: boolean;
}

export const HeaderField: React.FC<HeaderFieldProps> = ({
  field,
  value,
  onChange,
  onBlur,
  isStandalone = false,
}) => {
  const fieldConfig = field.fields;
  const fieldName = fieldConfig?.fieldName?.value || fieldConfig?.fieldId?.value;
  const defaultValue = fieldConfig?.defaultValue?.value;

  if (!fieldName) return null;

  const commonFieldProps = {
    name: fieldName,
    id: fieldName,
    type: 'hidden',
    'data-automation': `headerField-${fieldName}`,
  };

  return isStandalone ? (
    <input
      value={value ?? defaultValue ?? ''}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={onBlur}
      {...commonFieldProps}
    />
  ) : (
    <Field {...commonFieldProps} />
  );
};

export default HeaderField;
